/* eslint-disable import/no-duplicates */
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { OtpInput } from "reactjs-otp-input";
import {
  CheckBox as CheckBoxIcon,
  Receipt as ReceiptIcon,
  LocalShipping as LocalShippingIcon,
  ViewColumn as ViewColumnIcon,
} from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TabsNavigation, SlideModal } from "ctech-react-components";
import { handleUpdateOrderRequest } from "store/modules/Orders/thunk.store";
import { useAppDispatch } from "store/hooks";
import getOrderModalsProps from "./getOrderModalsProps";
import { useOrders } from "./useOrders";
import CardOrder from "./components/CardOrder";
import CancelOrderModal from "./components/CancelOrderModal";
import CardOrderDetails from "./components/CardOrderDetails";
import CardOrderKanban from "./components/CardOrderKanban";
import { useAuth } from "context/AuthContext";
import inputCode from "assets/supergasbras/images/inputCode.png";
import reasonCodePin from "assets/supergasbras/images/reasonCodePin.png";

import {
  Drawer,
  Modal,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import * as Styled from "./styles";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const OrderManagement: React.FC = () => {
  const {
    typeOrders,
    currentTab,
    typeDetailsKanban,
    setTypeDetailsKanban,
    modalProps,
    setModalProps,
    ordersSelected,
    setOrdersSelected,
    view,
    setView,
    openModal,
    setOpenModal,
    handleChangeTab,
    handleOrderUpdate,
    openModalCode,
    setOpenModalCode,
    setOpenModalFinallyOrder,
    openModalFinallyOrderDescription,
    setOpenModalFinallyOrderDescription,
  } = useOrders();

  const { t } = useTranslation();
  const { dealerId } = useAuth();
  const dispatch = useAppDispatch();
  const enabledPin = process.env.REACT_APP_ENABLE_PIN_ORDER;

  const [otp, setOtp] = useState("");
  const [reasonNotProvidePin, setReasonNotProvidePin] = useState("");
  const handleChange = (otpValue: string) => setOtp(otpValue);

  const tabsNavigation = useMemo(() => {
    return (
      <Styled.ContainerTabsNavigation kanban={view === "kanban"}>
        <TabsNavigation
          selectedTab={view === "kanban" ? "" : currentTab}
          tabs={[
            {
              label: `${t("newRequests").toUpperCase()} (${
                typeOrders("New").length
              })`,
              icon: <ReceiptIcon />,
              value: "1",
            },
            {
              label: `${t("ordersInProgress").toUpperCase()} (${
                typeOrders("InProgress").length
              })`,
              icon: <LocalShippingIcon />,
              value: "2",
            },
            {
              label: `${t("completedOrders").toUpperCase()} (${
                typeOrders("Finalized").length
              })`,
              icon: <CheckBoxIcon />,
              value: "3",
            },
          ]}
          onChangeTab={view === "kanban" ? () => "" : handleChangeTab}
          spaceAroundTabs
          tabStyle={{
            paddingLeft: 50,
            paddingRight: 50,
          }}
        />
      </Styled.ContainerTabsNavigation>
    );
  }, [currentTab, t, handleChangeTab, view, typeOrders]);

  const CardsAccordionNew = useMemo(() => {
    if (currentTab === "1" && typeOrders("New").length > 0) {
      return (
        <>
          <Styled.ContentHeader>
            {currentTab === "1" &&
              typeOrders("New").length > 0 &&
              typeOrders("New").map((order: any, index: any) => (
                <CardOrder
                  ordersSelected={ordersSelected}
                  indexSelected={index}
                  key={order.id}
                  data={order}
                  handleOrderAccept={handleOrderUpdate}
                  handleOrderUpdate={() => {
                    setOrdersSelected(index);
                    return handleOrderUpdate;
                  }}
                />
              ))}
          </Styled.ContentHeader>

          {ordersSelected !== null && !!typeOrders("New")[ordersSelected] && (
            <Styled.ContainerDetails>
              <CardOrderDetails
                openModalCode={() => setOpenModalCode(true)}
                currentTab={currentTab}
                data={typeOrders("New")[ordersSelected]}
                handleOrderUpdate={handleOrderUpdate}
              />
            </Styled.ContainerDetails>
          )}
        </>
      );
    }

    return "";
  }, [
    currentTab,
    typeOrders,
    ordersSelected,
    handleOrderUpdate,
    setOrdersSelected,
    setOpenModalCode,
  ]);

  const CardsAccordionInProgress = useMemo(() => {
    if (currentTab === "2" && typeOrders("InProgress").length > 0) {
      return (
        <>
          <Styled.ContentHeader>
            {typeOrders("InProgress").map((order: any, index: any) => (
              <CardOrder
                ordersSelected={ordersSelected}
                indexSelected={index}
                key={order.id}
                data={order}
                handleOrderUpdate={() => {
                  setOrdersSelected(index);
                  return handleOrderUpdate;
                }}
              />
            ))}
          </Styled.ContentHeader>
          {ordersSelected !== null &&
            !!typeOrders("InProgress")[ordersSelected] && (
              <Styled.ContainerDetails>
                <CardOrderDetails
                  openModalCode={() => setOpenModalCode(true)}
                  currentTab={currentTab}
                  data={typeOrders("InProgress")[ordersSelected]}
                  handleOrderUpdate={handleOrderUpdate}
                />
              </Styled.ContainerDetails>
            )}
        </>
      );
    }
    return "";
  }, [
    currentTab,
    typeOrders,
    ordersSelected,
    handleOrderUpdate,
    setOrdersSelected,
    setOpenModalCode,
  ]);

  const CardsAccordionInFinalized = useMemo(() => {
    if (currentTab === "3" && typeOrders("Finalized").length > 0) {
      return (
        <>
          <Styled.ContentHeader>
            {typeOrders("Finalized").map((order: any, index: any) => (
              <CardOrder
                ordersSelected={ordersSelected}
                indexSelected={index}
                key={order.id}
                data={order}
                handleOrderUpdate={() => {
                  setOrdersSelected(index);
                  return handleOrderUpdate;
                }}
              />
            ))}
          </Styled.ContentHeader>
          {ordersSelected !== null && (
            <Styled.ContainerDetails>
              <CardOrderDetails
                openModalCode={() => setOpenModalCode(true)}
                currentTab={currentTab}
                data={typeOrders("Finalized")[ordersSelected]}
                handleOrderUpdate={handleOrderUpdate}
              />
            </Styled.ContainerDetails>
          )}
        </>
      );
    }
    return "";
  }, [
    currentTab,
    typeOrders,
    ordersSelected,
    handleOrderUpdate,
    setOrdersSelected,
    setOpenModalCode,
  ]);

  const CardsAccordionInProgressKanban = useMemo(() => {
    if (typeOrders("InProgress").length > 0) {
      return typeOrders("InProgress").map((order: any, index: any) => (
        <CardOrderKanban
          ordersSelected={
            typeDetailsKanban.type === "InProgress" ? ordersSelected : null
          }
          indexSelected={index}
          key={order.id}
          data={order}
          handleOrderUpdate={() => {
            setOrdersSelected(index);
            setTypeDetailsKanban({
              type: "InProgress",
              currentTab: 2,
            });
            return handleOrderUpdate;
          }}
        />
      ));
    }
    return "";
  }, [
    typeOrders,
    typeDetailsKanban.type,
    ordersSelected,
    setOrdersSelected,
    setTypeDetailsKanban,
    handleOrderUpdate,
  ]);

  const CardsAccordionNewKanban = useMemo(() => {
    if (typeOrders("New").length > 0) {
      return (
        typeOrders("New").length > 0 &&
        typeOrders("New").map((order: any, index: any) => (
          <CardOrderKanban
            ordersSelected={
              typeDetailsKanban.type === "New" ? ordersSelected : null
            }
            indexSelected={index}
            key={order.id}
            data={order}
            handleOrderAccept={handleOrderUpdate}
            handleOrderUpdate={() => {
              setTypeDetailsKanban({
                type: "New",
                currentTab: 1,
              });
              setOrdersSelected(index);
              return handleOrderUpdate;
            }}
          />
        ))
      );
    }

    return "";
  }, [
    typeOrders,
    typeDetailsKanban.type,
    ordersSelected,
    handleOrderUpdate,
    setTypeDetailsKanban,
    setOrdersSelected,
  ]);

  const CardsAccordionInFinalizedKanban = useMemo(() => {
    if (typeOrders("Finalized").length > 0) {
      return (
        <>
          {typeOrders("Finalized").map((order: any, index: any) => (
            <CardOrderKanban
              ordersSelected={
                typeDetailsKanban.type === "Finalized" ? ordersSelected : null
              }
              indexSelected={index}
              key={order.id}
              data={order}
              handleOrderUpdate={() => {
                setTypeDetailsKanban({
                  type: "Finalized",
                  currentTab: 3,
                });
                setOrdersSelected(index);
                return handleOrderUpdate;
              }}
            />
          ))}
        </>
      );
    }
    return "";
  }, [
    typeOrders,
    typeDetailsKanban.type,
    ordersSelected,
    setTypeDetailsKanban,
    setOrdersSelected,
    handleOrderUpdate,
  ]);

  const modalRender = useMemo(() => {
    if (!modalProps) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>;
    }

    const onClose = () => setModalProps(null);
    const onConfirm = async (state?: unknown) => {
      await dispatch(
        handleUpdateOrderRequest({
          dealerId,
          type: modalProps?.type,
          orderId: modalProps?.orderId,
          body: enabledPin === "true" ? state : undefined,
          consumerId: modalProps?.consumerId,
          eta: modalProps?.type === "accept" ? 0 : null,
          reasonNotProvidePin:
            modalProps?.type === "finalize" &&
            reasonNotProvidePin?.length &&
            enabledPin === "true"
              ? reasonNotProvidePin
              : undefined,
          pin:
            modalProps?.type === "finalize" &&
            otp?.length &&
            enabledPin === "true"
              ? otp
              : undefined,
        }),
      )
        .unwrap()
        .finally();

      setReasonNotProvidePin("");
      setOtp("");
      setOrdersSelected(null);
      setOpenModalFinallyOrderDescription(false);
      setOpenModalFinallyOrder(false);
      setTypeDetailsKanban({
        type: "",
        currentTab: 0,
      });

      onClose();
    };

    const isCancelType = modalProps.type === "cancel";
    const isDenyType = modalProps.type === "deny";
    const isFinallyType = modalProps.type === "finalize";

    if (isCancelType) {
      return (
        <CancelOrderModal
          labelType="CANCEL"
          isOpen={!!modalProps}
          onClose={onClose}
          onConfirm={onConfirm}
        />
      );
    }
    if (isDenyType) {
      return (
        <CancelOrderModal
          labelType="DENY"
          isOpen={!!modalProps}
          onClose={onClose}
          onConfirm={onConfirm}
        />
      );
    }

    return enabledPin === "true" &&
      isFinallyType &&
      (modalProps?.paymentType === "INAPP" || modalProps?.valeGas) ? (
      <Modal
        open={enabledPin === "true"}
        onClose={() => {
          setOpenModalFinallyOrder(false);
          onClose();
          setReasonNotProvidePin("");
        }}
        style={{
          zIndex: 1500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {openModalFinallyOrderDescription ? (
          <Styled.ContentModalOTP>
            <Styled.TitleHeaderCode>
              <Typography variant="body2">
                {" "}
                <ArrowBackIcon />
                Atenção
              </Typography>

              <Styled.ButtonClose
                onClick={() => {
                  setOpenModalFinallyOrder(false);
                  onClose();
                }}
              />
            </Styled.TitleHeaderCode>

            <Styled.Image src={reasonCodePin} />

            <Styled.TitleBodyCodeOtp>
              <Typography
                variant="body2"
                textAlign="center"
                style={{ width: "380px" }}
                sx={{
                  fontSize: "15px",
                }}
              >
                Caso o cliente sinalize o não recebimento do pedido, o valor
                será reembolsado integralmente e essa venda será perdida
              </Typography>
            </Styled.TitleBodyCodeOtp>
            <Styled.ContainerTextField>
              <Styled.InputLabelContainer shrink htmlFor="reasonDescription">
                Motivo
              </Styled.InputLabelContainer>
              <Styled.TextFieldReason
                placeholder="Descreva o motivo de fechar o pedido sem código."
                onChange={(e) => setReasonNotProvidePin(e.target.value)}
                inputProps={{ maxLength: 150 }}
                sx={{
                  paddingBottom: "15px",
                  textTransform: "inherit",
                }}
              />
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{
                  position: "absolute",
                  bottom: 12,
                  right: 0,
                  fontSize: "0.8rem",
                }}
              >
                {`${reasonNotProvidePin.length}/${150}`}
              </Typography>
            </Styled.ContainerTextField>

            <Styled.ContainerButton>
              <Styled.ButtonModalCode
                onClick={() => {
                  setOpenModalFinallyOrderDescription(false);
                  setReasonNotProvidePin("");
                }}
                color="primary"
                variant="outlined"
                size="large"
              >
                VOLTAR
              </Styled.ButtonModalCode>
              <Styled.ButtonModalCode
                onClick={() => {
                  onConfirm({
                    origin: "DealerPortal",
                  });
                }}
                disabled={reasonNotProvidePin?.length < 4}
                color="primary"
                variant="contained"
                size="large"
              >
                FINALIZAR
              </Styled.ButtonModalCode>
            </Styled.ContainerButton>
          </Styled.ContentModalOTP>
        ) : (
          <Styled.ContentModalOTP>
            <Styled.TitleHeaderCode>
              <Typography variant="body2">
                {" "}
                <ArrowBackIcon />
                Finalizar Entrega
              </Typography>

              <Styled.ButtonClose
                onClick={() => {
                  setOpenModalFinallyOrder(false);
                  return onClose();
                }}
              />
            </Styled.TitleHeaderCode>

            <Styled.TitleBodyCodeOtp>
              <Typography variant="body2" style={{ width: "380px" }}>
                Para finalizar o pedido, digite o código informado pelo cliente
                no ato da entrega.
              </Typography>
            </Styled.TitleBodyCodeOtp>

            <OtpInput
              containerStyle={{
                marginBottom: "10%",
                alignSelf: "center",
              }}
              isInputNum
              inputStyle={{
                width: 40,
                height: 50,
                borderRadius: 8,
                borderWidth: 1,
              }}
              separator={<Styled.Separator />}
              value={otp}
              onChange={handleChange}
              numInputs={4}
            />

            <Styled.ButtonModalCodeOTP
              onClick={() => {
                setOpenModalFinallyOrderDescription(true);
              }}
            >
              Está sem o código de entrega?
            </Styled.ButtonModalCodeOTP>

            <Styled.ButtonModalCode
              onClick={() => {
                onConfirm({
                  origin: "DealerPortal",
                });
              }}
              disabled={otp?.length < 4}
              color="primary"
              variant="contained"
              size="large"
            >
              FINALIZAR PEDIDO
            </Styled.ButtonModalCode>
          </Styled.ContentModalOTP>
        )}
      </Modal>
    ) : (
      <SlideModal
        {...getOrderModalsProps(modalProps.type)}
        isOpen={!!modalProps}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    );
  }, [
    modalProps,
    enabledPin,
    openModalFinallyOrderDescription,
    reasonNotProvidePin,
    otp,
    setModalProps,
    dispatch,
    dealerId,
    setOrdersSelected,
    setOpenModalFinallyOrderDescription,
    setOpenModalFinallyOrder,
    setTypeDetailsKanban,
  ]);

  return (
    <Styled.Container>
      {modalRender}

      <Styled.ContainerHeaderSwitch kanban={view === "kanban"}>
        <Typography textAlign="center" color="#D33100">
          {`${format(new Date(), "eeee", { locale: ptBR })}, 
          ${format(new Date(Date()), "d", { locale: ptBR })} 
          de 
          ${format(new Date(Date()), "LLLL", { locale: ptBR })}
          de 
          ${format(new Date(Date()), "R", { locale: ptBR })}   
          ${format(new Date(Date()), "HH:mm")} 
          `}
        </Typography>
        <ToggleButtonGroup
          orientation="horizontal"
          value={view}
          exclusive
          onChange={(_, nextView: string) => {
            setView(nextView);
            localStorage.setItem("@ctech:ordersView", nextView);
            setOrdersSelected(null);
            setTypeDetailsKanban({
              type: "",
              currentTab: 0,
            });
          }}
        >
          <ToggleButton size="small" value="list" aria-label="list">
            <ViewColumnIcon />
          </ToggleButton>

          <ToggleButton size="small" value="kanban" aria-label="kanban">
            <ViewColumnIcon sx={{ transform: "rotate(90deg)" }} />
          </ToggleButton>
        </ToggleButtonGroup>
      </Styled.ContainerHeaderSwitch>

      {tabsNavigation}

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{ zIndex: 1500, justifyContent: "center", alignItems: "center" }}
      >
        <Styled.ContentModal>
          <Styled.TitleHeader>
            Bem vindo ao portal da revenda!
          </Styled.TitleHeader>

          <Styled.TitleBody>
            Aqui você pode acompanhar todos os seus pedidos
          </Styled.TitleBody>

          <Styled.ButtonModal
            onClick={() => {
              setOpenModal(false);
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            Vamos lá!
          </Styled.ButtonModal>
        </Styled.ContentModal>
      </Modal>

      <Modal
        open={openModalCode && enabledPin === "true"}
        onClose={() => setOpenModalCode(false)}
        style={{
          zIndex: 1500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Styled.ContentModal>
          <Styled.TitleHeaderCode>Atenção!</Styled.TitleHeaderCode>

          <Styled.TitleBodyCode>
            <Typography
              variant="subtitle2"
              textAlign="initial"
              sx={{ display: "inline" }}
            >
              Para a segurança da revenda e do cliente,{" "}
              <Typography
                component="span"
                variant="subtitle2"
                sx={{ fontWeight: "bold" }}
              >
                pedidos tipo VALE GÁS COLABORADOR OU PAGAMENTO ON-LINE
              </Typography>{" "}
              deverão ser finalizados mediante a um código de entrega gerado
              para o cliente. Lembre seus entregadores de pedir o código no
              momento de entrega!
            </Typography>
          </Styled.TitleBodyCode>

          <Styled.Image src={inputCode} />

          <Styled.ButtonModalCode
            onClick={() => {
              setOpenModalCode(false);
              localStorage.setItem("@ctech:firstAccessiWthoutRequest", "true");
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            ENTENDI
          </Styled.ButtonModalCode>
        </Styled.ContentModal>
      </Modal>

      <Drawer
        anchor="right"
        open={ordersSelected !== null && view !== "list"}
        onClose={() => {
          setOrdersSelected(null);
          setTypeDetailsKanban({
            type: "",
            currentTab: 0,
          });
        }}
      >
        {ordersSelected !== null && typeDetailsKanban && (
          <Styled.ContainerDetails fullHeight>
            <CardOrderDetails
              openModalCode={() => setOpenModalCode(true)}
              fullHeight
              currentTab={String(typeDetailsKanban.currentTab)}
              data={typeOrders(typeDetailsKanban.type)[ordersSelected]}
              handleOrderUpdate={handleOrderUpdate}
            />
          </Styled.ContainerDetails>
        )}
      </Drawer>
      {view === "list" ? (
        <Styled.ContainerOrders>
          {CardsAccordionNew}
          {CardsAccordionInProgress}
          {CardsAccordionInFinalized}
        </Styled.ContainerOrders>
      ) : (
        <Styled.ContainerOrdersKanban>
          <Styled.ContainerOrdersList>
            {CardsAccordionNewKanban}
          </Styled.ContainerOrdersList>
          <Styled.ContainerOrdersList>
            {CardsAccordionInProgressKanban}
          </Styled.ContainerOrdersList>
          <Styled.ContainerOrdersList>
            {CardsAccordionInFinalizedKanban}
          </Styled.ContainerOrdersList>
        </Styled.ContainerOrdersKanban>
      )}
    </Styled.Container>
  );
};

export default OrderManagement;
